import { render } from "./App.vue?vue&type=template&id=f39afde8&bindings={}"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "tailwindcss/tailwind.css?vue&type=style&index=0&lang=css"
script.render = render

export default script